/* IMPORTANT:
   This file intentionally duplicates the highlight styles defined in
   `styles/globals.css`.

   The iframe cannot reuse global styles directly, so we keep a local copy here.
   Do NOT change these values only here – always update both files together. */
export const HIGHLIGHT_STYLE = `
[data-highlight='true'] {
  background-color: rgb(var(--color-yellow) / 0.6);
  padding-top: 2px;
  padding-bottom: 2px;
}
`
